import { render, staticRenderFns } from "./act-reg.vue?vue&type=template&id=4770ac4a&scoped=true&"
import script from "./act-reg.vue?vue&type=script&lang=js&"
export * from "./act-reg.vue?vue&type=script&lang=js&"
import style0 from "./act-reg.vue?vue&type=style&index=0&id=4770ac4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770ac4a",
  null
  
)

export default component.exports